export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount'
export const DAEMON = '@@saga-injector/daemon'
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount'
export const ENV = 'production'
export const IS_LOCAL = window.location.origin.includes('dev.local.me')
export const IS_DEV = ENV === 'develop'
export const IS_PRODUCTION = ENV === 'production'
export const HOST = IS_LOCAL ? 'dev.local.me:3000' : 'app.godonde.com'
export const BASE_URL = IS_LOCAL
  ? 'https://dev.local.me:3000'
  : 'https://app.godonde.com'
export const LOGOUT_URL = `${BASE_URL}/logout`
export const IS_BOOKING = !!window?.location?.href?.includes(
  'booking.godonde.com'
)
export const BUILD_ID = '2000'
// export const SESSION_TIMEOUT = 1000
export const SESSION_TIMEOUT = 1000 * 60 * 60 * 2
export const PERSONA_ENV = IS_PRODUCTION ? 'production' : 'production'

export const DONDE = {
  NUMBERS: {
    AGENT: 'XXX-XXX-XXXX',
    SUPPORT: 'tel:2134636633',
    SUPPORT_FORMATTED: '(213) 463-6633',
  },
  LINKS: {
    BOOKING: 'mailto:booking@godonde.com?subject=',
    BOOKING_EMPTY: 'mailto:booking@godonde.com?subject=Booking',
    SUPPORT: 'mailto:support@godonde.com?subject=Support',
    SUPPORT_EMPTY: 'mailto:support@godonde.com?subject=',
    END_USER_AGREEMENT: 'https://cdn1.godonde.com/terms-of-service.pdf',
    PRIVACY_POLICY: 'https://cdn1.godonde.com/privacy-policy.pdf',
    PLATFORM_LICENSE: '',
    TERMS_OF_SERVICE: '',
  },
}

export const API = {
  BASE_URL: 'https://api.godonde.com/api/v1',
}

export const CLOUDINARY_PRESETS = {
  DEFAULT: 'am05q662',
  CUSTOMER_LOGO: 'lqejzsln',
  COMPANY_PHOTOS: 'nxuj8nyh',
  CUSTOMER_SERVICE: 'wzvmvbp2',
}

export const HOST_KEYS = {
  GTM: 'GTM-KXZSJDV',
}

export const API_KEYS = {
  PLACES: 'AIzaSyBkrLO4Ljyyf18PgyGyXi-R1ML_R7ENOsg',
  MAPS: 'AIzaSyBkrLO4Ljyyf18PgyGyXi-R1ML_R7ENOsg',
  MUI: 'a7c08c50f30fcad89d11f1dddb6ad66dTz03OTU2MCxFPTE3MzI4MTExMTEwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
}

export const CDN = {
  PLAID: {
    URL: 'https://cdn.plaid.com/link/v2/stable/link-initialize.js',
    CLIENT_NAME: 'Dónde',
    ENV: 'production',
    PRODUCT: ['auth'],
    // ACCOUNT_FILTERS: {
    //   depository: {
    //     account_subtypes: ['checking', 'savings'],
    //   },
    // }
  },
  CLOUDINARY: {
    URL: 'https://widget.cloudinary.com/v2.0/global/all.js',
    OPTIONS: {
      cloudName: 'donde',
      cropping: true,
      croppingShowDimensions: true,
      multiple: false,
      gravity: 'custom',
      croppingValidateDimensions: true,
      // maxImageFileSize: 50000000,
      minImageWidth: 300,
      minImageHeight: 300,
      // moderation: 'perception_point',
    },
    OPTIONS_PROFILE: {
      cloudName: 'donde',
      // uploadPreset: CLOUDINARY_PRESETS.DEFAULT,
      cropping: true,
      croppingAspectRatio: true,
      croppingShowDimensions: true,
      multiple: false,
      gravity: 'custom',
      // validateMaxWidthHeight: true,
      croppingValidateDimensions: true,
      // maxImageFileSize: 50000000,
      // maxImageWidth: 300,
      // maxImageHeight: 300,
      minImageWidth: 300,
      minImageHeight: 300,
      thumbnailTransformation: [{ width: 300, height: 300, crop: 'fit' }],
      // moderation: 'perception_point',
      // maxImageWidth: 300,
      // maxImageHeight: 300,
    },
    OPTIONS_COMPANY: {
      cloudName: 'donde',
      multiple: true,
      maxFiles: 10,
      gravity: 'custom',
      // moderation: 'perception_point',
      // showCompletedButton: true,
    },
    OPTIONS_CUSTOMER_SERVICE: {
      cloudName: 'donde',
      multiple: true,
      maxFiles: 10,
      gravity: 'custom',
      type: 'private',
    },
  },
  PLACES: {
    URL: `https://maps.googleapis.com/maps/api/js?key=${API_KEYS.PLACES}&language=en&libraries=places`,
  },
  CHAT: {
    URL: '//chat-assets.frontapp.com/v1/chat.bundle.js',
    CHAT_ID: 'd4e080b82848e38c850a58e230dabafa',
    APP_ID: IS_DEV ? 'app-6e9e9d8e096c4eafbf7cf3a769c9c59c' : 'app-905e93a7cdb04b3281e42d5cfeb3baf0', // MEYA
    // APP_ID: IS_DEV ? 'app-7f322ee9d32d4612b5e866b04c7ffee2' : 'app-905e93a7cdb04b3281e42d5cfeb3baf0', // MEYA
  },
}

export const ROLES = {
  CUSTOMER_ADMIN: 'Customer_Admin',
  MANAGER: 'MANAGER',
  ADMIN: 'ADMIN',
}

export const TRANSACTION_STATUS = {
  NEW: 1,
  IN_PROGRESS: 2,
  COMPLETE: 3,
  FAILED: 4,
  CANCELLED: 5,
  CANCELLING: 6,
}

export const TRANSACTION_TYPE = {
  RECURRING: 1,
  EMPLOYEE_BOOST: 2,
  COMPANY_BOOST: 3,
  COMPANY_MATCH: 4,
  CORRECTION: 5,
  PURCHASE: 6,
  POINTS_INCREASE: 11,
}

export const TRANSACTION_SUB_TYPE = {
  MANAGER_INCENTIVE: 1,
}

export const CHANGE_TRANSACTION_TYPE = {
  INCREASE: 1,
  DECREASE: 2,
}

export const REVELEX = {
  A_KEY: 'akey=7paszNAKIOGonNF0',
  C_KEY: 'ckey=79bbf163f',
  CLEAR: 'clear=all',
  // CLEAR: 'clear=instance',
  BASE_URL: 'https://booking.godonde.com',
  ENV: '',
  PAGE: '/search.html',
  DIRECTORY: '/app/0/',
  SUBDIRECTORY: '/0',
}

// OCEAN_CRUISE: 'https://booking.godonde.com/DONDEDEV-9/app/0/cruise/0/search.html?clear=instance&ckey=79bbf163f&akey=7paszNAKIOGonNF0',
// RIVER_CRUISE: 'https://booking.godonde.com/DONDEDEV-9/app/0/river_cruise/0/search.html?clear=instance&ckey=79bbf163f&akey=7paszNAKIOGonNF0',
// CAR: 'https://booking.godonde.com/DONDEDEV-9/app/0/car/0/search.html?clear=instance&ckey=79bbf163f&akey=7paszNAKIOGonNF0',
// HOTEL: 'https://booking.godonde.com/DONDEDEV-9/app/0/hotel/0/search.html?clear=instance&ckey=79bbf163f&akey=7paszNAKIOGonNF0',
// FLIGHT: 'https://booking.godonde.com/DONDEDEV-9/app/0/air/0/search.html?clear=instance&ckey=79bbf163f&akey=7paszNAKIOGonNF0',

export const TRAVEL_SEARCH = {
  OCEAN_CRUISE: `${REVELEX.BASE_URL}/${REVELEX.ENV}${REVELEX.DIRECTORY}cruise${
    REVELEX.SUBDIRECTORY
  }/search_cruises.html?${REVELEX.CLEAR}&${REVELEX.C_KEY}&${REVELEX.A_KEY}`,
  RIVER_CRUISE: `${REVELEX.BASE_URL}/${REVELEX.ENV}${
    REVELEX.DIRECTORY
  }river_cruise${REVELEX.SUBDIRECTORY}/search_cruises.html?${REVELEX.CLEAR}&${
    REVELEX.C_KEY
  }&${REVELEX.A_KEY}`,
  CAR: `${REVELEX.BASE_URL}/${REVELEX.ENV}${REVELEX.DIRECTORY}car${
    REVELEX.SUBDIRECTORY
  }/search_car.html?${REVELEX.CLEAR}&${REVELEX.C_KEY}&${REVELEX.A_KEY}`,
  HOTEL: `${REVELEX.BASE_URL}/${REVELEX.ENV}${REVELEX.DIRECTORY}hotel${
    REVELEX.SUBDIRECTORY
  }/search_hotels.html?${REVELEX.CLEAR}&${REVELEX.C_KEY}&${REVELEX.A_KEY}`,
  HOTEL_DEEP: `${REVELEX.BASE_URL}/${REVELEX.ENV}${REVELEX.DIRECTORY}hotel${
    REVELEX.SUBDIRECTORY
  }/room_availability.html?${REVELEX.CLEAR}&${REVELEX.C_KEY}&${REVELEX.A_KEY}`,
  FLIGHT: `${REVELEX.BASE_URL}/${REVELEX.ENV}${REVELEX.DIRECTORY}air${
    REVELEX.SUBDIRECTORY
  }/search_flights.html?${REVELEX.CLEAR}&${REVELEX.C_KEY}&${REVELEX.A_KEY}`,
}

export const WALLET_VENDOR = {
  DWOLLA: 0,
  BOND: 1,
}

export const DWOLLA_STATUS = {
  DEFAULT: 0,
  UNVERIFIED: 1,
  VERIFIED: 2,
  RETRY: 3,
  DOCUMENT: 4,
  SUSPENDED: 5,
  DEACTIVATED: 6,
  REACTIVATED: 7,
  KBA: 8,
  SUBMITTED: 9,
}

export const DWOLLA_SUB_STATUS = {
  CREATED: 'customer_created',
  REVERIFICATION_NEEDED: 'customer_reverification_needed',
  VERIFICATION_DOCUMENT_NEEDED: 'customer_verification_document_needed',
  VERIFICATION_DOCUMENT_UPLOADED: 'customer_verification_document_uploaded',
  VERIFICATION_DOCUMENT_FAILED: 'customer_verification_document_failed',
  VERIFICATION_DOCUMENT_APPROVED: 'customer_verification_document_approved',
  VERIFIED: 'customer_verified',
  SUSPENDED: 'customer_suspended',
  ACTIVATED: 'customer_activated',
  DEACTIVATED: 'customer_deactivated',
  VERIFY_WITH_DOCUMENT: 'verify-with-document',
  VERIFY_BUSINESS_WITH_DOCUMENT: 'verify-business-with-document',
  VERIFY_CONTROLLER_AND_BUSINESS_WITH_DOCUMENT:
    'verify-controller-and-business-with-document',
  KBA_VERIFICATION_FAILED: 'customer_kba_verification_failed',
  KBA_VERIFICATION_PASSED: 'customer_kba_verification_passed',
  KBA_VERIFICATION_NEEDED: 'customer_kba_verification_needed',
  KBA_PRE_SUBMIT: 'kba_pre_submit',
  DOCUMENTS_PRE_SUBMIT: 'documents_pre_submit',
  DOCUMENT_UPLOADING: 'document_uploading',
}

export const BENEFICIAL_OWNER_STATUS = {
  CERTIFIED: 'certified',
  VERIFIED: 'verified',
  DOCUMENT: 'document',
  UNCERTIFIED: 'uncertified',
  RECERTIFY: 'recertify',
  INCOMPLETE: 'incomplete',
}

export const PLAID_STATUS = {
  PENDING_AUTOMATIC_VERIFICATION: 'pending_automatic_verification',
  AUTOMATICALLY_VERIFIED: 'automatically_verified',
  PENDING_MANUAL_VERIFICATION: 'pending_manual_verification',
  MANUALLY_VERIFIED: 'manually_verified',
  VERIFICATION_EXPIRED: 'verification_expired',
  VERIFICATION_FAILED: 'verification_failed',
  DWOLLA_VERIFIED: 'customer_funding_source_verified',
  ITEM_LOGIN_REQUIRED: 'item_login_required',
}

export const KEYS = {
  DELETE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CONTROL: 17,
  ALT: 18,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  DELETE_FORWARD: 46,
  COMMAND: 91,
}

export const CONTROLS = {
  BACK: [KEYS.ARROW_LEFT, KEYS.ARROW_UP],
  FORWARD: [KEYS.ARROW_RIGHT, KEYS.ARROW_DOWN],
  ARROWS: [KEYS.ARROW_UP, KEYS.ARROW_RIGHT, KEYS.ARROW_DOWN, KEYS.ARROW_LEFT],
}

export const FREQUENCY = {
  WEEK: 2,
  MONTH: 1,
  MONDAY: 0,
  TUESDAY: 1,
  WEDNESDAY: 2,
  THURSDAY: 3,
  FRIDAY: 4,
  SATURDAY: 5,
  SUNDAY: 6,
  BEGIN: 1,
  MIDDLE: 15,
  MONTHLY_MAX_COMPARE: 1,
  YEARLY_MAX_COMPARE: 2,
}

export const FREQUENCY_TYPES = {
  1: {
    value: 'MONTH',
    moment_value: 'months',
  },
  2: {
    value: 'WEEK',
    moment_value: 'weeks',
  },
}

export const MONTHLY_FREQUENCY_VALUES = {
  1: {
    value: 'BEGIN',
    moment_value: 1,
  },
  15: {
    value: 'MIDDLE',
    moment_value: 15,
  },
}

export const WEEKLY_FREQUENCY_VALUES = {
  0: {
    value: 'MONDAY',
    moment_value: 1,
  },
  1: {
    value: 'TUESDAY',
    moment_value: 2,
  },
  2: {
    value: 'WEDNESDAY',
    moment_value: 3,
  },
  3: {
    value: 'THURSDAY',
    moment_value: 4,
  },
  4: {
    value: 'FRIDAY',
    moment_value: 5,
  },
  5: {
    value: 'SATURDAY',
    moment_value: 6,
  },
  6: {
    value: 'SUNDAY',
    moment_value: 0,
  },
}

export const PROFILE = {
  ID: 'id',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  EMAIL: 'email',
  LEGAL_NAME: 'legal_name',
  BIRTH_DATE: 'birth_date',
  KNOWN_TRAVELLER_NUMBER: 'known_traveler_number',
  CUSTOMER: 'customer',
  PASSPORTS: 'passports',
  TRAVEL_PROGRAMS: 'travel_programs',
  IMAGE: 'profile_image_url',
  COMPANY_IMAGE: 'company_image',
  COMPANY_NAME: 'company_name',
  COMPANY_PAGE: 'company_page',
  COMPANY: 'company',
  PASSWORD: 'password',
  CREATED_AT: 'created_at',
  TYPE: 'type',
  PRIMARY_PASSPORT_ID: 'primary_passport_id',
}

export const PASSPORT = {
  NAME: 'name',
  NUMBER: 'number',
  EXPIRATION_DATE: 'expiration_date',
  COUNTRY: 'country_code',
  NATIONALITY: 'nationality_code',
  IMAGE: 'image',
}

export const TRAVEL_PROGRAM = {
  ID: 'id',
  TYPE: 'type',
  COMPANY: 'company',
  NUMBER: 'number',
}

export const STATUS = {
  SYSTEM: {
    ACTIVE: 'active',
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
  },
}

export const INVESTMENT = {
  TYPE: {
    YOUR_CONTRIBUTION: 'your_contribution',
    COMPANY_CONTRIBUTION: 'company_contribution',
    RECURRING_DEPOSIT: 'recurring_deposit',
    ONE_TIME_DEPOSIT: 'one_time_deposit',
    EMPLOYER_BONUS: 'employer_bonus',
    COMPANY_BONUS: 'company_bonus',
  },
  SETTING: {
    DAYS_REMAINING: 'days_remaining',
  },
}

export const FILTER = {
  DISPLAY_ALL: 'display_all',
  DIRECT_DEPOSITS: 'direct_deposit',
  WITHDRAWALS: 'withdrawals',
  REIMBURSEMENTS: 'reimbursements',
  FILTERS: 'filters',
}

export const VIEW = {
  ACCOUNT_SETTINGS: 'settings',
  TRAVELER_PROFILE: 'traveler-profile',
  AIRLINE_LOYALTY: 'airline_loyalty',
  HOTEL_LOYALTY: 'hotel_loyalty',
  CAR_RENTAL: 'car_rental',
}

export const TABLE = {
  TEAM_MEMBER: 'team_member',
  ACCOUNT_NUMBER: 'account_number',
  ROLE: 'role',
  LAST_SEEN: 'last_login',
  MONTHLY_CONTRIBUTION: 'monthly_contribution',
  TOTAL_CONTRIBUTION: 'total_contribution',
}

export const FIELD = {
  PROFILE,
  PASSPORT,
  TRAVEL_PROGRAM,
  LOYALTY: {
    AIRLINE_LOYALTY_PROGRAM: 'airline_loyalty_program',
    AIRLINE_LOYALTY_NUMBER: 'airline_loyalty_number',
    HOTEL_LOYALTY_PROGRAM: 'hotel_loyalty_program',
    HOTEL_LOYALTY_NUMBER: 'hotel_loyalty_number',
    CAR_RENTAL_PROGRAM: 'car_rental_program',
    CAR_RENTAL_NUMBER: 'car_rental_number',
  },
}

export const LOYALTY = {
  IDS: {
    AIRLINE: 1,
    AUTO: 2,
    HOTEL: 3,
    OTHER: 4,
  },
}

export const ONBOARDING_STEPS = {
  SET_INTENTION: 0,
  ADD_PROFILE_IMAGE: 1,
  ADD_PERSONAL_INFORMATION: 2,
  ADD_TRAVELER_INFORMATION: 3,
  LINK_ACCOUNTS: 4,
  ADD_PAYMENT_METHODS: 5,
}

export const TRAVEL_STATUS = {
  NEW: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
}

export const TRAVEL_TYPES = {
  AIR: 1,
  HOTEL: 2,
  CAR: 3,
  CRUISE: 4,
  EXPERIENCE: 5,
}

export const USER_ACCOUNT_STATUS = {
  ALL: 0,
  ACTIVE: 1,
  INACTIVE: 2,
  DEACTIVATED: 3,
}

export const BUDGET_STATUS = {
  ALL: 0,
  ACTIVE: 'Active',
  LOCKED: 'Locked',
  FUTURE: 'Future',
}

// weekday: 'narrow' | 'short' | 'long'
// year: 'numeric' | '2-digit'
// month: 'numeric' | '2-digit' | 'narrow' | 'short' | 'long'
// day: 'numeric' | '2-digit'
// timeZone:
// hour12: true | false
// hour: 'numeric' | '2-digit'
// minute: 'numeric' | '2-digit'
// second: 'numeric' | '2-digit'

export const DATE_FORMAT = {
  LOG: {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  },
  LONG: { year: 'numeric', month: 'short', weekday: 'short', day: 'numeric' },
  LONG_NO_WEEKDAY: { year: 'numeric', month: 'short', day: 'numeric' },
  LONG_SHORT_WEEKDAY: { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' }, // Thu, September 29, 2022
  LONG_NO_YEAR: { month: 'short', weekday: 'short', day: 'numeric' },
  LONG_NO_YEAR_NO_WEEKDAY: { month: 'short', day: 'numeric' },
  LONG_NO_YEAR_FULL_WEEKDAY: {
    month: 'short',
    weekday: 'long',
    day: 'numeric',
  },
  LONG_NO_YEAR_FULL_MONTH_FULL_WEEKDAY: {
    month: 'long',
    weekday: 'long',
    day: 'numeric',
  },
  LONG_NO_YEAR_SHORT_WEEKDAY: {
    month: 'short',
    weekday: 'short',
    day: 'numeric',
  },
  STATEMENT_LOG: {
    month: 'short',
    day: 'numeric',
  },
  ACTIVITY_LOG: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
  YEAR: { year: 'numeric' },
  DURATION: { hour: 'numeric', minute: '2-digit' },
  DATE_AND_TIME: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  },
  SIMPLE_DATE: { month: 'numeric', day: 'numeric' },
  SHORT_DATE: { month: 'numeric', day: 'numeric', year: '2-digit' },
  FULL_DATE: { month: '2-digit', day: '2-digit', year: 'numeric' },
  NUMERIC: { month: 'numeric', day: 'numeric', year: 'numeric' },
}

export const TIME_FORMAT = {
  TIME: { hour: 'numeric', minute: '2-digit', hour12: true },
  TIME_NO_SECONDS: { hour: 'numeric', minute: '2-digit', hour12: true, second: undefined },
}

export const LETTERS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]

export const EMPLOYMENT_TYPES = {
  SALARIED_FULL_TIME: 0,
  SALARIED_PART_TIME: 1,
  HOURLY_FULL_TIME: 2,
  HOURLY_PART_TIME: 3,
  CONTRACTOR: 4,
}

export const HRIS_SYNC_STATUS = {
  COMPLETE: 'Complete',
  INCOMPLETE: 'Incomplete',
  ERROR: 'Error',
  RUNNING: 'Running',
}

export const HRIS_STATUS = {
  SYNC_IN_ERROR: 'sync_in_error',
  SYNC_NOT_COMPLETE: 'sync_not_complete',
  SYNC_NO_DATA: 'sync_received_no_data',
  NEEDS_ELIGIBILITY_RULES: 'needs_eligibility_rules',
  NEEDS_MERGE_EMPLOYEES: 'needs_merge_employees',
  NEEDS_APPROVE_ELIGIBLE_EMPLOYEES: 'needs_approve_eligible_employees',
  MERGE_ISSUE_LOG: 'needs_merge_issue_review',
  COMPLETE: 'complete',
}

export const HRIS_USER_STATUS = {
  NOT_MERGED: 0,
  SUCCESSFULLY_MERGED: 1,
  NOT_FOUND: 2,
  ERROR: 3,
}

export const HRIS_ACCOUNT_STATUS = {
  INCOMPLETE: 0,
  COMPLETE: 1,
  RELINK_NEEDED: 2,
}

export const HRIS_CODES = {
  MISSING_HIRE_DATE: 'missing_hire_date',
  MISSING_EMPLOYEE_NUMBER: 'missing_employee_number',
  MISSING_EMAIL: 'missing_email',
  MISSING_FIRST_NAME: 'missing_first_name',
  MISSING_LAST_NAME: 'missing_last_name',
  MISSING_TEAM: 'missing_team',
  MISSING_EMPLOYMENT_TYPE: 'missing_employment_type',
  NO_LONGER_ELIGIBLE: 'no_longer_eligible',
  SYNC_ERROR: 'sync_error',
  MULTIPLE_USERS: 'multiple_users',
}

export const INTENTIONS = {
  adventure: {
    icon: 'CelAdventure',
    primary: '#E4B242',
    primaryLight: '#F0ECE0',
    card: '#F4D592',
  },
  immersion: {
    icon: 'CelImmersion',
    primary: '#03BEF3',
    primaryLight: '#D9ECF1',
    card: '#03BEF3',
  },
  mindfulness: {
    icon: 'CelMindfulness',
    primary: '#FF98BA',
    primaryLight: '#F2E8ED',
    card: '#FF98BA',
  },
  selfDiscovery: {
    icon: 'CelSelfDiscovery',
    primary: '#813C83',
    primaryLight: '#E7DFE6',
    card: '#BC80E0',
  },
  connection: {
    icon: 'CelConnection',
    primary: '#9757BC',
    primaryLight: '#E9E2EC',
    card: '#D7B0ED',
  },
  wanderlust: {
    icon: 'CelWanderlust',
    primary: '#7AA6CE',
    primaryLight: '#E6EBEF',
    card: '#B2D8FF',
  },
  relaxation: {
    icon: 'CelRelaxation',
    primary: '#FF9F00',
    primaryLight: '#F3E9DA',
    card: '#FFC928',
  },
}

export const MIGRATION_STATUS = {
  0: 'NOT_STARTED',
  1: 'PENDING_TRANSACTION_CHECK',
  2: 'READY_TO_START',
  3: 'IN_PROCESS',
  4: 'WITHDRAW',
  5: 'FROZEN',
  6: 'MIGRATION_COMPLETE',
  7: 'DID_NOT_MIGRATE',
  NOT_STARTED: 0,
  PENDING_TRANSACTION_CHECK: 1,
  READY_TO_START: 2,
  IN_PROCESS: 3,
  WITHDRAW: 4,
  FROZEN: 5,
  MIGRATION_COMPLETE: 6,
  DID_NOT_MIGRATE: 7,
}
